import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ButtonStyle, ButtonVariant, Icon, TypeStyle } from '../../../base/src/abcButton/abcButton';

@Component({
    selector: '',
    template: `<div class="devExButton">
    <dx-button
      #dxButton
      [width]="width"
      [height]="height"
      [icon]="icon"
      hint="{{ hint }}"
      [disabled]="disabled"
      [focusStateEnabled]="focusStateEnabled"
      [hoverStateEnabled]="hoverStateEnabled"
      [rtlEnabled]="rtlEnabled"
      [type]="type"
      [text]="value"
      [visible]="visible"
      [class]="class"
      [stylingMode]="stylingMode"
      (onClick)="onClickButton($event)"
    >
    </dx-button>
  </div>`,
    standalone: false
})
export class DevExButtonComponent implements OnInit {
  @ViewChild('dxButton', { static: true }) dxButton: any;
  @Input() width: string;
  @Input() height: string;
  @Input() icon: Icon;
  @Input() hint: string;
  @Input() focusStateEnabled: boolean;
  @Input() hoverStateEnabled: boolean;
  @Input() visible: boolean;
  @Input() class: string;
  @Input() value: string;
  @Input() disabled: boolean;
  @Input() rtlEnabled: boolean;
  @Input() type: TypeStyle;
  @Input() stylingMode: ButtonVariant;
  @Output() onClick = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  setButtonStyle(style: ButtonStyle): void {
    if (this.dxButton) {
      const element = this.dxButton.element.nativeElement;
      if (style) {
        for (let key in style) {
          element.style[key] = style[key];
        }
      }
    }
  }

  onClickButton(e) {
    this.onClick.emit(e);
  }
}
